var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fk-input-container"},_vm._l((_vm.length),function(input,index){return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputValues[index]),expression:"inputValues[index]"}],key:index,ref:_vm.generateInputId(index),refInFor:true,style:({
      fontSize: _vm.fkFontSize,
      borderBottom: _vm.fkInputColor(index),
      color: _vm.fontColor,
      width: _vm.fkWidth,
      'background-color': '#ECEFF1',
      'border-radius': '8px 8px 8px 8px',
      'padding-left': '10px',
      'padding-right': '10px'
    }),attrs:{"id":_vm.generateInputId(index),"type":"text","maxlength":"1","contenteditable":"true"},domProps:{"value":(_vm.inputValues[index])},on:{"keyup":function($event){return _vm.handleInputFocus(index)},"paste":function($event){$event.preventDefault();return _vm.handlePastedValues.apply(null, arguments)},"input":[function($event){if($event.target.composing)return;_vm.$set(_vm.inputValues, index, $event.target.value)},function($event){return _vm.returnFullString()}]}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }